import React from "react";
import OrderTaskForm from "./OrderTaskForm";

// Tarea «Entregar a domicilio» (actor DESPACHO) — FORMCODE ELDOM
const CONFIG = {
  stage: 1,
  title: "Entregar a domicilio",
  intro: "Lleva el pedido a la dirección del cliente.",
  sections: ["pedido", "productos", "montos", "cliente", "entrega", "facturacion"],
  checklist: [
    "Confirma dirección y referencia; usa el teléfono o WhatsApp si hace falta.",
    "Si el pago es al momento de la entrega, cobra el monto indicado.",
    "Si no se pudo entregar, márcalo para reprogramar.",
  ],
  optionHints: {
    "Entregado": "Cierra el pedido.",
    "No entregado": "Pasa a Reprogramar entrega.",
  },
};

export default function ElevaxEntregarDomicilio(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
